module.exports = __webpack_public_path__ + "static/media/Localizacao.88de780e.svg";